export default __webpack_public_path__ + "static/media/banner-3.71ffc7a7.jpg";